import React, { FunctionComponent, useState } from "react";
import "./dateField.css";
import { DateInput } from "components/inputs/DateInput";
import { pipe } from "fp-ts/lib/function";
import { option } from "fp-ts";
import { useRubriek } from "components/aangifte/useRubriek";
import { Rubriek } from "components/aangifte/Rubriek";

interface DateFieldState {
  value?: string;
  error?: JSX.Element;
  isPartialDate?: boolean;
}

export const DateField: FunctionComponent<React.InputHTMLAttributes<HTMLInputElement>> = ({ name, ...props }) => {
  const rubriekO = useRubriek(name as string);
  const [{ value, error, isPartialDate }, setDateState] = useState<DateFieldState>(() => {
    return pipe(
      rubriekO,
      option.fold(
        () => ({}),
        (rubriek) => ({ value: rubriek.value, error: undefined })
      )
    );
  });

  const showError = !isPartialDate && !!error;

  return (
    <Rubriek code={name as string}>
      {({ updateValue }) => {
        const handleDateChanged = ({ value, error, isPartialDate }: DateFieldState) => {
          setDateState({ value, error, isPartialDate });
          if (!error && !isPartialDate) updateValue(value);
        };
        return (
          <div className={`dateField ${showError ? "error" : ""}`}>
            <DateInput {...props} name={name} value={value || ""} onDateChanged={handleDateChanged} />
            {showError && error}
          </div>
        );
      }}
    </Rubriek>
  );
};

DateField.displayName = "DateField";
